import { lazy } from 'react';

const importDashboardView = widgetComponent =>
	lazy(() =>
		import(`components/widgets/dashboard/${widgetComponent}`).catch(() =>
			import(`components/widgets/NullView`)
		)
	);

export default importDashboardView;